import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    localStorage.setItem('analytics_enabled', 'true');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    localStorage.setItem('analytics_enabled', 'false');
    // Disable PostHog tracking
    if (window.posthog) {
      window.posthog.opt_out_capturing();
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={styles.banner} data-testid="cookie-consent-banner">
      <div style={styles.content}>
        <div style={styles.textContainer}>
          <p style={styles.text}>
            We use cookies and similar technologies to analyze site traffic and improve your experience. 
            We may share information with analytics partners.
            {' '}
            <button 
              onClick={() => setShowDetails(!showDetails)} 
              style={styles.learnMore}
            >
              {showDetails ? 'Show less' : 'Learn more'}
            </button>
          </p>
          
          {showDetails && (
            <div style={styles.details}>
              <p style={styles.detailText}>
                <strong>Information we collect:</strong> Device information, browsing activity, and form submissions (name, email, company info).
              </p>
              <p style={styles.detailText}>
                <strong>Your rights (CA/CO residents):</strong> You have the right to opt-out of the sale or sharing of your personal information 
                and targeted advertising. Click "Do Not Sell/Share" to exercise these rights.
              </p>
            </div>
          )}
        </div>
        
        <div style={styles.buttons}>
          <button 
            onClick={handleDecline} 
            style={styles.declineButton}
            data-testid="cookie-decline-btn"
          >
            Do Not Sell/Share
          </button>
          <button 
            onClick={handleAccept} 
            style={styles.acceptButton}
            data-testid="cookie-accept-btn"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'rgba(10, 26, 64, 0.98)',
    backdropFilter: 'blur(8px)',
    padding: '16px 24px',
    zIndex: 10000,
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.2)',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '24px',
    flexWrap: 'wrap',
  },
  textContainer: {
    flex: 1,
    minWidth: '280px',
  },
  text: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '0.875rem',
    margin: 0,
    lineHeight: 1.5,
  },
  learnMore: {
    background: 'none',
    border: 'none',
    color: '#60a5fa',
    fontSize: '0.875rem',
    cursor: 'pointer',
    padding: 0,
    textDecoration: 'underline',
  },
  details: {
    marginTop: '12px',
    padding: '12px',
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '6px',
  },
  detailText: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '0.8125rem',
    margin: '0 0 8px 0',
    lineHeight: 1.5,
  },
  buttons: {
    display: 'flex',
    gap: '12px',
    flexShrink: 0,
    alignItems: 'center',
  },
  declineButton: {
    background: 'transparent',
    color: 'rgba(255, 255, 255, 0.9)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    padding: '10px 20px',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: 500,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s ease',
  },
  acceptButton: {
    background: '#3b82f6',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background 0.2s ease',
  },
};

export default CookieConsent;
